<style scoped src="./Modal.scss" lang="scss"></style>
<template>
  <section v-if="open" class="modal-root" >
    <div class="modal-root__container" :class="{ big: big }">
      <slot/>
    </div>
  </section>
</template>

<script>
export default {
  props:{
    open: {
      type: Boolean,
      default: false
    },
    big:{
      type:Boolean,
      default: false
    }
  }

}

</script>